/*
 * ==========================================================================
 * SingRank - GEO / AI-visibility pixel for kgteknik.co.id       v1.0.0
 * --------------------------------------------------------------------------
 * Ported 2026-09-01 from the proven ablink build (three-way detection).
 * Answers one question: which AI assistant is sending people to KG Teknik,
 * and to which page. Fires ONE 1x1 gif at leads.rumah.live, and ONLY when the
 * visit is actually AI-related - a normal Google or direct visit sends
 * nothing at all.
 *
 *   k=referral  a human arrived from an AI assistant
 *   k=crawler   an AI bot fetched the page
 *
 * THREE WAYS A REFERRAL IS DETECTED, because one is not enough:
 *   1. document.referrer host (chatgpt.com, gemini.google.com, claude.ai, ...)
 *   2. utm_source on the URL - AI assistants increasingly tag their outbound
 *      links instead of sending a referrer ("?utm_source=chatgpt.com" hits
 *      carry NO referrer at all in our own data).
 *   3. a "ref" / "source" param carrying the same names.
 *
 * SLUG IS "kgteknik" - matches the existing leads bucket and CLIENT_ALIASES.
 *
 * SAFETY
 * - Renders nothing, blocks nothing, never runs on a non-AI visit.
 * - No cookies, no localStorage, no personal data.
 * - Guarded by window.__SR_GEO_PIXEL__ so a second copy is a no-op.
 * - try/catch throughout; on failure the page is unaffected.
 * - No regular expressions and no escape sequences, by house rule.
 *
 * DEBUG
 *   window.SR_GEO_PIXEL.state()  what it decided, and whether it sent
 *   window.SR_GEO_PIXEL.test()   force a send, for install verification
 *
 * Maintained by SingRank. Created 2026-09-01.
 * ==========================================================================
 */
(function () {
  'use strict';

  if (window.__SR_GEO_PIXEL__) { return; }
  window.__SR_GEO_PIXEL__ = true;

  var ENDPOINT = 'https://leads.rumah.live/px.gif';
  var SLUG = 'kgteknik';

  var SOURCES = [
    ['chatgpt',      'chatgpt'],
    ['openai',       'chatgpt'],
    ['oai-search',   'chatgpt'],
    ['gemini',       'gemini'],
    ['bard.google',  'gemini'],
    ['claude.ai',    'claude'],
    ['anthropic',    'claude'],
    ['perplexity',   'perplexity'],
    ['copilot',      'copilot'],
    ['bing.com/chat','copilot'],
    ['you.com',      'you'],
    ['poe.com',      'poe'],
    ['phind',        'phind'],
    ['mistral',      'mistral'],
    ['grok',         'grok'],
    ['x.ai',         'grok'],
    ['deepseek',     'deepseek'],
    ['meta.ai',      'meta']
  ];

  var BOTS = [
    ['gptbot',            'chatgpt'],
    ['oai-searchbot',     'chatgpt'],
    ['chatgpt-user',      'chatgpt'],
    ['claudebot',         'claude'],
    ['claude-web',        'claude'],
    ['anthropic-ai',      'claude'],
    ['perplexitybot',     'perplexity'],
    ['perplexity-user',   'perplexity'],
    ['google-extended',   'gemini'],
    ['googleother',       'gemini'],
    ['applebot-extended', 'applebot'],
    ['bingbot',           'copilot'],
    ['ccbot',             'ccbot'],
    ['bytespider',        'bytespider'],
    ['amazonbot',         'amazonbot'],
    ['youbot',            'you'],
    ['meta-externalagent','meta'],
    ['facebookbot',       'meta'],
    ['diffbot',           'diffbot'],
    ['timpibot',          'timpi']
  ];

  var STATE = { checked: false, kind: '', source: '', via: '', sent: false };

  function low(s) { return String(s == null ? '' : s).toLowerCase(); }

  function firstMatch(haystack, table) {
    var h = low(haystack);
    if (!h) { return ''; }
    for (var i = 0; i < table.length; i++) {
      if (h.indexOf(table[i][0]) > -1) { return table[i][1]; }
    }
    return '';
  }

  function param(name) {
    try {
      var q = window.location.search || '';
      if (!q) { return ''; }
      var parts = q.substring(1).split('&');
      for (var i = 0; i < parts.length; i++) {
        var eq = parts[i].indexOf('=');
        if (eq < 0) { continue; }
        if (decodeURIComponent(parts[i].substring(0, eq)).toLowerCase() === name) {
          return decodeURIComponent(parts[i].substring(eq + 1).split('+').join(' '));
        }
      }
    } catch (e) {}
    return '';
  }

  function referrerHost() {
    try {
      var r = document.referrer || '';
      if (!r) { return ''; }
      var host = new URL(r).hostname;
      if (low(host).indexOf(low(window.location.hostname)) > -1) { return ''; }
      return host;
    } catch (e) { return ''; }
  }

  function decide() {
    STATE.checked = true;

    var bot = firstMatch(navigator.userAgent, BOTS);
    if (bot) {
      STATE.kind = 'crawler';
      STATE.source = bot;
      STATE.via = 'user-agent';
      return true;
    }

    var byRef = firstMatch(referrerHost(), SOURCES);
    if (byRef) {
      STATE.kind = 'referral';
      STATE.source = byRef;
      STATE.via = 'referrer';
      return true;
    }

    var tagged = param('utm_source') || param('ref') || param('source');
    var byTag = firstMatch(tagged, SOURCES);
    if (byTag) {
      STATE.kind = 'referral';
      STATE.source = byTag;
      STATE.via = 'utm';
      return true;
    }

    return false;
  }

  function send(force) {
    try {
      var q = ENDPOINT
        + '?c=' + encodeURIComponent(SLUG)
        + '&k=' + encodeURIComponent(STATE.kind || 'referral')
        + '&s=' + encodeURIComponent(STATE.source || 'unknown')
        + '&u=' + encodeURIComponent(window.location.href)
        + '&t=' + encodeURIComponent((document.title || '').substring(0, 300))
        + '&ref=' + encodeURIComponent(document.referrer || '')
        + '&_=' + String(new Date().getTime());
      var img = new Image(1, 1);
      img.referrerPolicy = 'no-referrer-when-downgrade';
      img.src = q;
      STATE.sent = true;
      if (force) { STATE.via = STATE.via || 'manual-test'; }
      return q;
    } catch (e) { return ''; }
  }

  window.SR_GEO_PIXEL = {
    version: '1.0.0',
    slug: SLUG,
    state: function () { return STATE; },
    test: function () {
      STATE.kind = STATE.kind || 'referral';
      STATE.source = STATE.source || 'manual-test';
      return send(true);
    }
  };

  try {
    if (decide()) { send(false); }
  } catch (e) {}
})();
